var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMageUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3483 17.7084C16.3483 14.7067 13.0016 12.2667 9.99994 12.2667C6.99828 12.2667 3.65161 14.7067 3.65161 17.7084M9.99994 9.54669C10.962 9.54669 11.8847 9.16451 12.565 8.48422C13.2453 7.80393 13.6274 6.88126 13.6274 5.91919C13.6274 4.95711 13.2453 4.03445 12.565 3.35416C11.8847 2.67387 10.962 2.29169 9.99994 2.29169C9.03787 2.29169 8.1152 2.67387 7.43492 3.35416C6.75463 4.03445 6.37244 4.95711 6.37244 5.91919C6.37244 6.88126 6.75463 7.80393 7.43492 8.48422C8.1152 9.16451 9.03787 9.54669 9.99994 9.54669Z",
    stroke: "#FB6161",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageUser);
export default __webpack_public_path__ + "static/media/mage_user.12b0b1cc73ffb4a2d629e9e5a6333f08.svg";
export { ForwardRef as ReactComponent };